import React from 'react'
import { PRIORITY_ROUTINE } from '../../config/constants'

const PriorityLabel = ({label}) => (
  (PRIORITY_ROUTINE !== label) && <div className={'app-label ' + label + ' rounded ml-1'} style={{ display: 'inline' }} />  
)

export default PriorityLabel
